import { render, staticRenderFns } from "./RateList.vue?vue&type=template&id=28633986&scoped=true&"
import script from "./RateList.vue?vue&type=script&lang=js&"
export * from "./RateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28633986",
  null
  
)

export default component.exports